<template>
	<span>
		{{ outputDate  }}
	</span>
</template>

<script>
	export default {
		props: ['date'],

		data() {
			return {
				outputDate: ''
			}
		},

		mounted() {
			let date = this.$props.date;
			let year = date.split('-')[0];
			let months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
			let month = Number(date.split('-')[1]);
			let day = date.split('-')[2].split(' ')[0];
			this.outputDate = `${day} de ${months[month-1]}  ${year}`;

		}
	}
</script>